module.exports = __webpack_public_path__ + "img/negocios.54f81ead.png";